import { createRoot } from 'react-dom/client';
import App from './app/App';
import { installModuleLoadRecovery } from './app/module-load-recovery';
import './theme/global.css';

installModuleLoadRecovery();

async function enableMocking() {
  if ((import.meta.env.VITE_ENABLE_MOCK ?? 'true') !== 'true') return;
  const { worker } = await import('./mocks/browser');
  await worker.start({ onUnhandledRequest: 'bypass', serviceWorker: { url: '/mockServiceWorker.js' } });
}

void enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(<App />);
});
